import { WifiOff } from "lucide-react";
import { useTranslation } from "react-i18next";

export function ConnectionLost() {
	const { t } = useTranslation();

	return (
		<div
			className="flex flex-col items-center gap-4 glass-card rounded-2xl p-12 text-center"
			role="alert"
		>
			<WifiOff className="h-10 w-10 text-error" aria-hidden="true" />
			<h2 className="text-lg font-semibold text-primary">{t("error.connectionLost")}</h2>
			<p className="text-sm text-secondary">{t("error.connectionLostDesc")}</p>
		</div>
	);
}
